export default __webpack_public_path__ + "static/media/image2.9b62fd7c.jpg";